import { render, staticRenderFns } from "./match-overall.vue?vue&type=template&id=081ec6d5&"
import script from "./match-overall.vue?vue&type=script&lang=js&"
export * from "./match-overall.vue?vue&type=script&lang=js&"
import style0 from "./match-overall.vue?vue&type=style&index=0&id=081ec6d5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports